<template>
  <div>
    <event-registry-events-from-integration-widget :contractId="contractId" @updateAssetComponents="updateAssetComponents"/>
  </div>
</template>
<script>
export default {
  computed: {
    contractId() {
      return this.$route.params.id;
    },
  },
  methods: {
    updateAssetComponents(assetComponents) {
      this.$emit('updateAssetComponents', assetComponents);
    }
  }
};
</script>
